// extracted by mini-css-extract-plugin
module.exports = {"thumbnail-image":"EventModal_thumbnail-image__1Msj-"};